// extracted by mini-css-extract-plugin
export var checkbox = "_85-0";
export var circle = "_85-3";
export var horizontalContainer = "_85-7";
export var sm = "_85-5";
export var switch0 = "_85-2";
export var switchDisabled = "_85-8";
export var switchEnabled = "_85-1";
export var textSwitchContainer = "_85-9";
export var textSwitchOption = "_85-a";
export var textSwitchOptionSelected = "_85-b";
export var verticalContainer = "_85-6";
export var xs = "_85-4";